export function formatCPF(cpf: string): string {
  const cleaned = cpf.replace(/\D/g, ''); // Remove tudo que não for número

  return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}
